"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _formGroup = _interopRequireDefault(require("../../core/form-group"));
var _label = _interopRequireDefault(require("../../core/label"));
var _col = _interopRequireDefault(require("../../core/col"));
var _rowConfig = _interopRequireDefault(require("../../core/row-config"));
var _alert = _interopRequireDefault(require("../../core/alert"));
var _inputOnBlur = _interopRequireDefault(require("../../core/input-on-blur"));
var _constantParams = require("../../../constant-params");
var _emailFilter = _interopRequireDefault(require("./email-filter"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// *******************************************************************************
// Main Component
// *******************************************************************************
var _ref = /*#__PURE__*/_react.default.createElement(_alert.default, {
  type: "danger"
}, /*#__PURE__*/_react.default.createElement("p", {
  className: "lead"
}, "When sending group emails always use back copy (bcc) to keep the email addresses private."), /*#__PURE__*/_react.default.createElement("p", null, "For large groups consider splitting into multiple emails to avoid spam filters"));
var _ref2 = /*#__PURE__*/_react.default.createElement(_label.default, null, "Slalom Year");
class ContactOrganisers extends _react.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", {
      yearID: _constantParams.thisYear
    });
    _defineProperty(this, "_setYear", value => {
      this.setState({
        yearID: value
      });
    });
  }
  render() {
    return /*#__PURE__*/_react.default.createElement("div", null, _ref, /*#__PURE__*/_react.default.createElement(_rowConfig.default, {
      columns: [{
        sm: 2,
        lg: 1
      }, {
        sm: 3,
        lg: 2
      }]
    }, /*#__PURE__*/_react.default.createElement(_formGroup.default, null, _ref2, /*#__PURE__*/_react.default.createElement(_col.default, null, /*#__PURE__*/_react.default.createElement(_inputOnBlur.default, {
      type: "Year",
      name: "yearID",
      value: this.state.yearID,
      onChange: this._setYear,
      maxLength: 4
    })))), /*#__PURE__*/_react.default.createElement(_emailFilter.default, {
      yearID: this.state.yearID
    }));
  }
}
// *******************************************************************************
// Data and actions
// *******************************************************************************
var _default = exports.default = ContactOrganisers;